<template>
  <div class="step-title">
    <span class="step-title__number">{{ stepNumber }}</span>
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'step-title',
    props: {
      stepNumber: { type: [Number, String], required: true }
    }
  }
</script>

<style lang="scss" scoped>
@import '~scss/variables';

.step-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  color: $color-graphite;
  gap: 10px;
  width: 100%;

  &__number {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: $color-graphite;
    color: $color-mint;
    font-weight: 700;
    font-size: 18px;
    flex-shrink: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/common/UI/StepTitle.vue